import { render, staticRenderFns } from "./industry_index_s.vue?vue&type=template&id=23c11316&scoped=true"
import script from "./industry_index_s.vue?vue&type=script&lang=js"
export * from "./industry_index_s.vue?vue&type=script&lang=js"
import style0 from "./industry_index_s.vue?vue&type=style&index=0&id=23c11316&prod&rel=stylesheet%2Fscss&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23c11316",
  null
  
)

export default component.exports